<template>
  <div class="is-fullwidth">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{price}}
        </p>
      </header>
      <section class="modal-card-body">
        <div v-for="(segment, index) in segments" class="segment-row-wrapper">
          <segment-row :segment=segment :showTooltip=showTooltip :tooltipPos=tooltipPos(index)></segment-row>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" v-on:click="$parent.close()">Close</button>
        <button class="button is-primary" v-on:click="addToCart">Add to Cart</button>
      </footer>
    </div>
  </div>
</template>

<script>
  import SegmentRow from './SegmentRow';
  export default {
    name: 'ItineraryModal',
    components: {
      'segment-row': SegmentRow,
    },
    props: ['itinerary'],
    data() {
      return {};
    },
    methods: {
      isTouch: function () {
        return 'ontouchstart' in document.documentElement;
      },
      tooltipPos: function (i) {
        if (i % 2 && this.isTouch())  return 'is-left'
        return 'is-right'
      },
      addToCart: function () {
        this.$emit('add-to-cart');
      }
    },
    computed: {
      segments: function () {
        if (this.itinerary.departing_segments.length > 0) {
          return this.itinerary.departing_segments.sort((a, b) => a.index - b.index);
        }
        return this.itinerary.returning_segments.sort((a, b) => a.index - b.index);
      },
      showTooltip: function () {
        return !this.isTouch()
      },
      price: function () {
        if (this.itinerary && this.itinerary.total_price) {
          return `$${parseFloat(this.itinerary.total_price).toFixed(2)}`
        }
        return ''
      }
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .itin-modal {
    border: 1px solid #eee;
    border-radius: 5px;
  }

  .segment-row-wrapper {
    margin: 10px 0;
  }

  * {
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/ItineraryModal.vue